import moment from 'moment';
import request from 'axios';
import { getPinsFromLocalStorage, getCrsLabel } from '../utils/utils';
import { fetchProbaVSearchResults, getProbaVDates } from '../utils/ajax';
let RES = ''
const axios = require('axios')

let arrayConverter =  (arr)=>{
    let ret_obj = {}; // the new array to be returned
    arr.forEach(element => { // loop over each element in the array
      let key = element.$.name;  // get the value of the object in the $ to be used as the key for the new object, e.g. "family_name"
      let value = element._; // get the value of the object in the _ to be used as the value for the new object, e.g. "Sentinel-2"
      ret_obj[key] = value // assigne key and value
    });
    return ret_obj // return the new array
  }


let getpreviewimage = function(tile) {
      let conv_obj = arrayConverter(tile['str'])
      let theurl= `https://space.kay.ichec.ie/search?product_name=${conv_obj.product_name}`
      const xyz = request.get(theurl)
      .then(res => {
      const parseStringFromXml = require('xml2js').parseString;
      let full_data = (parseStringFromXml(res.data))
      var mySubString = res.data.substring(res.data.lastIndexOf("<thumbnail>"), res.data.lastIndexOf("</thumbnail>"));
      var parser = new DOMParser;
      var dom = parser.parseFromString(mySubString,'text/html');
      var decodedString = dom.body.textContent;
      tile.thumbnail =  decodedString
      });
      return tile.thumbnail }


var path = require('path')
const views = {
  PRESETS: '1',
  BANDS: '2',
  SCRIPT: '3',
};
const imageFormats = [
  { text: 'JPG (no georeference)', value: 'image/jpeg', ext: 'jpg' },
  { text: 'PNG (no georeference)', value: 'image/png', ext: 'png' },
  {
    text: 'KMZ/JPG',
    value: 'application/vnd.google-earth.kmz+xml;image_type=image/jpeg',
    ext: 'kmz',
  },
  {
    text: 'KMZ/PNG',
    value: 'application/vnd.google-earth.kmz+xml;image_type=image/png',
    ext: 'kmz',
  },
  { text: 'TIFF (8-bit)', value: 'image/tiff;depth=8', ext: 'tiff' },
  { text: 'TIFF (16-bit)', value: 'image/tiff;depth=16', ext: 'tiff' },
  { text: 'TIFF (32-bit float)', value: 'image/tiff;depth=32f', ext: 'tiff' },
  // { text: 'JPEG 2000 (JP2)', value: 'image/jp2', ext: 'jp2' } //jp2 removed till supported
];
const CRS_MAP = {
  'Popular Web Mercator (EPSG:3857)': 'EPSG:3857',
  'WGS 84 (EPSG:4326)': 'EPSG:4326',
};
const RESOLUTIONS = {
  LOW: 4,
  MEDIUM: 2,
  HIGH: 1,
};
const availableCrs = Object.keys(CRS_MAP).map(key => ({
  text: key,
  value: CRS_MAP[key],
}));
const resolutions = Object.keys(RESOLUTIONS).map(key => ({
  text: key,
  value: RESOLUTIONS[key],
}));

export const FILTER_CLOUD_COVERAGE_PERCENT = 'cloudCoverPercentage';

export const DATASOURCE_GROUPS = [
  {
    label: 'Sentinel-1',
    id: 'SENTINEL-1',
    search: {
      preselected: false,
    },
  },
  {
    label: 'Sentinel-2',
    id: 'SENTINEL-2',
    search: {
      preselected: true,
      filters: {
        [FILTER_CLOUD_COVERAGE_PERCENT]: 100,
      },
    },
  },
  {
    label: 'Sentinel-3',
    id: 'SENTINEL-3',
    search: {
      preselected: false,
    },
  },
  {
    label: 'Sentinel-5P',
    id: 'S5P',
    search: {
      preselected: false,

    },
  },
  {
    label: 'Envisat Meris',
    id: 'ENVISAT',
    search: {
      preselected: false,
    },
  },
  {
    label: 'MODIS',
    id: 'MODIS',
    search: {
      preselected: false,
    },
  },
  {
    label: 'Proba-V',
    id: 'PROBAV',
    search: {
      preselected: false,
    },
  },
];

export const DATASOURCES = [
  {
    name: 'Sentinel 5 ',
    id: 'S5p',
    group: 'S5P',
    baseUrls: {
      WMS: 'https://eocloud.sentinel-hub.com/v1/wms/e3e5e6c2-d1eb-419a-841c-5167a1de5441',
    },
    search: {
      tooltip: 'Europe and North Africa from 1984 to 2013',
      label: 'Sentinel 5P ',
      preselected: false,
      searchableByArea: true,
    },
    minDate: '1984-01-01',
    maxDate: '2013-05-01',
    typename: '',
    getEOPath: function(tile) {
      let theurl= 'https://eobrowser.speir.ichec.ie/api/api-url/?scene='+tile.title[0]+'.nc&expiry=4600'
      const xyz = request.get(theurl)
      .then(res => {
      let RES = res.data.url
      tile.signedurl = res.data.url

      }).then(reso =>{

      return reso
      })
      .catch(e => {
        return e;
      });
      return RES
      },
    getPreviewImage: function(tile) {
      return ``;
    },
    minZoom: 10,
    indexService: `https://space.kay.ichec.ie/search?family_name=Sentinel-5p`,
    dateService: `https://eocloud.sentinel-hub.com/index/landsat5/v2/dates`,
    previewPrefix: 'https://finder.eocloud.eu/files',
    resolution: 30,
  },/*
  {
    name: 'Landsat 8 ESA',
    id: 'L8',
    group: 'LANDSAT',
    baseUrls: {
      WMS: 'https://eocloud.sentinel-hub.com/v1/wms/2d8dbfcb-5fa0-4198-ba57-8ad594c3757e',
    },
    search: {
      tooltip: 'Europe and North Africa from 2013/02 onward',
      label: 'Landsat 8 (ESA archive)',
      preselected: false,
      searchableByArea: true,
    },
    typename: 'L8.TILE',
    minDate: '2013-01-01',
    minZoom: 10,
    getEOPath: function(tile) {
      const { pathFragment } = tile;
      return pathFragment.substring(0, pathFragment.lastIndexOf('/') + 1);
    },
    getPreviewImage: function(tile) {
      return `${this.previewPrefix}${tile.pathFragment.replace('/eodata', '')}.png`;
    },
    indexService: `https://eocloud.sentinel-hub.com/index/landsat8/v2`,
    previewPrefix: 'https://finder.eocloud.eu/files',
    dateService: `https://eocloud.sentinel-hub.com/index/landsat8/v2/dates`,
    resolution: 30,
  },*/
  {
    name: 'Sentinel-1 GRD IW',
    id: 'S1',
    group: 'SENTINEL-1',
    baseUrls: {
      WMS: 'https://eocloud.sentinel-hub.com/v1/wms/6a6b787f-0dda-4153-8ae9-a1729dd0c890',
    },
    search: {
      tooltip: 'Worldwide from 2014/04/03 onward',
      label: 'GRD IW',
      preselected: true,
      searchableByArea: true,
    },
    typename: 'DSS3.TILE',
    minDate: '2014-04-03',
    getEOPath: function(tile) {
      let theurl= 'https://eobrowser.speir.ichec.ie/api/api-url/?scene='+tile.title[0].replace("SAFE","zip")+'&expiry=4600'
      const xyz = request.get(theurl)
      .then(res => {
      let RES = res.data.url
      tile.signedurl = res.data.url

      }).then(reso =>{

      return reso
      })
      .catch(e => {
        return e;
      });
      return RES
      },
    previewPrefix: 'https://finder.eocloud.eu/files',
    getPreviewImage: function(tile) {
      return ``;
    },
    indexService: `https://space.kay.ichec.ie/search?family_name=Sentinel-1&mode=IW`,
    dateService: `https://eocloud.sentinel-hub.com/index/s1/v1/finddates`,
    resolution: 10,
  },
  {
    name: 'Sentinel-1 GRD EW',
    id: 'S1_EW',
    group: 'SENTINEL-1',
    baseUrls: {
      WMS: 'https://eocloud.sentinel-hub.com/v1/wms/52803c64-23ae-4c61-88e1-1859aa98a8c8',
    },
    search: {
      tooltip: 'Worldwide (near the poles) from 2014/04/03 onward',
      label: 'GRD EW',
      preselected: true,
      searchableByArea: true,
    },
    indexService: `https://space.kay.ichec.ie/search?family_name=Sentinel-1&mode=EW`,
    typename: 'DSS3.TILE',
    minDate: '2014-04-03',
    getEOPath: function(tile) {
      let theurl= 'https://eobrowser.speir.ichec.ie/api/api-url/?scene='+tile.title[0].replace("SAFE","zip")+'&expiry=4600'
      const xyz = request.get(theurl)
      .then(res => {
      let RES = res.data.url
      tile.signedurl = res.data.url

      }).then(reso =>{

      return reso
      })
      .catch(e => {
        return e;
      });
      return RES
      },
    previewPrefix: 'https://finder.eocloud.eu/files',
    getPreviewImage: function(tile) {
      return ``;
    },
    indexSuffix: `&acquisitionMode=EW&polarization=DH&productType=GRD&resolution=MEDIUM`,
    resolution: 40,
  },
  {
    name: 'Sentinel-1 GRD EW SH',
    id: 'S1_EW_SH',
    group: 'SENTINEL-1',
    baseUrls: {
      WMS: 'https://eocloud.sentinel-hub.com/v1/wms/3f532158-bdf9-461a-8bb0-dbdd3a810b3f',
    },
    search: {
      tooltip: 'Worldwide (near the poles) from 2014/04/03 onward',
      label: 'GRD EW SH',
      preselected: true,
      searchableByArea: true,
    },
    indexService: `https://space.kay.ichec.ie/search?family_name=Sentinel-1&mode=WV`,
    typename: 'DSS3.TILE',
    minDate: '2014-04-03',
    getEOPath: function(tile) {
      let theurl= 'https://eobrowser.speir.ichec.ie/api/api-url/?scene='+tile.title[0].replace("SAFE","zip")+'&expiry=4600'
      const xyz = request.get(theurl)
      .then(res => {
      let RES = res.data.url
      tile.signedurl = res.data.url

      }).then(reso =>{

      return reso
      })
      .catch(e => {
        return e;
      });
      return RES
      },
    previewPrefix: 'https://finder.eocloud.eu/files',
    getPreviewImage: function(tile) {
      return '';
    },
    indexSuffix: `&acquisitionMode=EW&polarization=SH&productType=GRD&resolution=MEDIUM`,
    resolution: 40,
  },
  {
    name: 'Sentinel-2 L1C',
    id: 'S2L1C',
    group: 'SENTINEL-2',
    baseUrls: {
      //WMS: 'https://services.sentinel-hub.com/ogc/wms/ef26381d-8fec-4417-a8bb-a59549731e16',
      WMS:'https://eocloud.sentinel-hub.com/v1/wms/1180d546-51af-442e-9a06-d490007ab3a5',
      FIS: 'https://services.sentinel-hub.com/ogc/fis/ef26381d-8fec-4417-a8bb-a59549731e16',
    },
    search: {
      tooltip: 'Global archive from 2016/07 onward',
      label: 'L1C',
      preselected: true,
      searchableByArea: true,
    },
    typename: 'S2.TILE',
    minDate: '2015-01-01',
    getPreviewImage: function getImage(tile){
    return getpreviewimage(tile)
    },

    getEOPath: function(tile) {
      let theurl= 'https://eobrowser.speir.ichec.ie/api/api-url/?scene='+tile.title[0].replace("SAFE","zip")+'&expiry=4600'
      const xyz = request.get(theurl)
      .then(res => {
      let RES = res.data.url
      tile.signedurl = res.data.url

      }).then(reso =>{

      return reso
      })
      .catch(e => {
        return e;
      });
      return RES
      }
      ,

    getTileUrl: function(tile) {
      //return `https://services.sentinel-hub.com/index/s2/v3/tiles/${tile.id}`;
      return " ";
    },

    getCrsLabel: function(tile) {
      return getCrsLabel(tile);
    },
    previewPrefix: 'https://sentinel-s2-l1c.s3.amazonaws.com',
    awsLink: 'http://sentinel-s2-l1c.s3-website.eu-central-1.amazonaws.com/',

    indexService: `https://space.kay.ichec.ie/search?family_name=Sentinel-2&instrument_family_short=MSI&processing_level=L1C`,
    dateService: `https://services.sentinel-hub.com/index/v3/collections/S2L1C/findAvailableData`,
    resolution: 10,
  },

  {
    name: 'Sentinel-3 OLCI',
    id: 'S3',
    group: 'SENTINEL-3',
    baseUrls: {
      WMS: 'https://eocloud.sentinel-hub.com/v1/wms/1180d546-51af-442e-9a06-d490007ab3a5',
    },
    search: {
      tooltip: 'Global archive from 2016 onward',
      label: 'OLCI',
      preselected: false,
      searchableByArea: true,
    },
    typename: 'DSS3.TILE',
    minDate: '2016-01-01',
    maxDate: '2018-03-18',
    minZoom: 6,
    previewPrefix: 'https://finder.eocloud.eu/files',
      getEOPath: function(tile) {
      let theurl= 'https://eobrowser.speir.ichec.ie/api/api-url/?scene='+tile.title[0].replace("SEN3","zip")+'&expiry=4600'
      const xyz = request.get(theurl)
      .then(res => {
      let RES = res.data.url
      tile.signedurl = res.data.url

      }).then(reso =>{

      return reso
      })
      .catch(e => {
        return e;
      });
      return RES
      },

    getPreviewImage: function(tile) {

      return '';
      },

    indexService: 'https://space.kay.ichec.ie/search?family_name=Sentinel-3&instrument_family_short=OLCI',
    dateService: `https://eocloud.sentinel-hub.com/index/s3/v1/finddates`,
    resolution: 300,
  },
  {
    name: 'Sentinel-3 SR',
    id: 'S3SR',
    group: 'SENTINEL-3',
    baseUrls: {
      WMS: 'https://eocloud.sentinel-hub.com/v1/wms/1180d546-51af-442e-9a06-d490007ab3a5',
    },
    search: {
      tooltip: 'Global archive from 2016 onward',
      label: 'SR',
      preselected: false,
      searchableByArea: true,
    },
    typename: 'DSS3.TILE',
    minDate: '2016-02-01',
    minZoom: 6,
    previewPrefix: 'https://finder.eocloud.eu/files',

    getEOPath: function(tile) {
      let theurl= 'https://eobrowser.speir.ichec.ie/api/api-url/?scene='+tile.title[0].replace("SEN3","zip")+'&expiry=4600'
      const xyz = request.get(theurl)
      .then(res => {
      let RES = res.data.url
      tile.signedurl = res.data.url

      }).then(reso =>{

      return reso
      })
      .catch(e => {
        return e;
      });
      return RES
      },
    getPreviewImage: function(tile) {
      return '';
    },
    indexService: 'https://space.kay.ichec.ie/search?family_name=Sentinel-3&instrument_family_short=SRAL',
    dateService: `https://eocloud.sentinel-hub.com/index/s3/v1/finddates`,
    resolution: 300,
  },
];

const DATASET_MAP = {
  S2L1C: 'Sentinel-2 L1C',
  S2L2A: 'Sentinel-2 L2A',
};

const config = {
  datasetMap: DATASET_MAP,
  layers: {},
  startLocation: '',
  imageFormats,
  resolutions,
  availableCrs,
  resolution: RESOLUTIONS.MEDIUM,
  selectedCrs: availableCrs[0].value,
  imageFormat: imageFormats[0].value,
  imageExt: imageFormats[0].ext,
  doRefresh: true,
  datasources: [DATASOURCES.find(inst => inst.id === 'S2L1C').name],
  instances: DATASOURCES, // use only if you need user's instances, otherwise import and use DATASOURCES directly
  isLoaded: true,
  isSearching: false,
  searchResults: {},
  searchFilterResults: {},
  searchParams: {},
  lat: 53.272,
  lng: -7.712,
  zoom: 7,
  size: [0, 0],
  opacity: 100,
  maxcc: 100,
  imgWmsUrl: '',
  mapBounds: null,
  showLogo: true,
  minDate: moment('1984-03-01'),
  maxDate: moment(),
  dateFrom: moment().subtract(1, 'months'),
  dateTo: moment(),
  dateFormat: 'YYYY-MM-DD',
  availableDays: [],
  preset: {},
  currView: views.PRESETS,
  channels: {},
  mainTabIndex: 0,
  path: '',
  presets: {},
  colCor: '',
  isActiveLayerVisible: true,
  compareMode: false,
  isAnalytical: false,
  evalscript: {},
  evalscripturl: {},
  isEvalUrl: false,
  user: null,
  selectedResult: null,
  compareModeType: 'opacity',
  modalDialogs: [],
  pinResults: getPinsFromLocalStorage(),
  defaultPolyStyle: {
    weight: 1,
    color: '#398ade',
    opacity: 0.8,
    fillColor: '#398ade',
    fillOpacity: 0.15,
  },
  highlightPolyStyle: {
    weight: 2,
    color: '#57de71',
    opacity: 1,
    fillColor: '#57de71',
    fillOpacity: 0.3,
  },
  views,
};

export default config;



// WEBPACK FOOTER //
// src/store/config.js